import { configureStore } from "@reduxjs/toolkit"
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from "react-redux"
import { persistStore, persistReducer } from "redux-persist"
import { rootPersistConfig, rootReducer } from "./rootReducer"

//-------------------
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// ----------------------------------------------------------------------

const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false
    }),
  devTools: process.env.NODE_ENV !== 'production' && {
    maxAge: 50, // Keep only last 50 actions to reduce memory usage
    actionSanitizer: (action: any) => {
      // Limit payload size to prevent excessive serialization
      const stringified = JSON.stringify(action)
      if (stringified.length > 100000) {
        return {
          ...action,
          payload: '[Large payload - exceeds 100KB]'
        }
      }
      return action
    },
    stateSanitizer: (state: any) => {
      // Limit state size to prevent excessive serialization
      const stringified = JSON.stringify(state)
      if (stringified.length > 1000000) {
        return {
          ...state,
          largeDataWarning: '[State exceeds 1MB - DevTools serialization limited]'
        }
      }
      return state
    }
  }
})

const persistor = persistStore(store)

const { dispatch } = store

const useSelector = useReduxSelector
const useDispatch = () => useReduxDispatch<AppDispatch>()

export { store, persistor, dispatch, useSelector, useDispatch }
